<template>
    <header>
        <div class="nav_main">
            <div class="nav_left">
                <img src="../assets/logo.png" alt="" />
                <nav>
                    <ul>
                        <li :class="nav_select == 1 ? 'li_select' : ''">
                            <router-link to="/">
                                <p style="display: flex;align-items: center;">
                                    <img class="img_icon" :src="nav_select == 1 ? getAssetsFile('shouye2.png') : getAssetsFile('shouye1.png')" alt="">
                                    <span>首页</span>
                                </p>
                            </router-link>
                            <p class="selectxian"></p>
                        </li>
                        <li :class="nav_select == 2 ? 'li_select' : ''">
                            <router-link to="/AncientWorks">
                                <p style="display: flex;align-items: center;">
                                    <img class="img_icon" :src="nav_select == 2 ? getAssetsFile('shuji2.png') : getAssetsFile('shuji1.png')" alt="">
                                    <span>古籍书库</span>
                                </p>
                            </router-link>
                            <p class="selectxian"></p>
                        </li>
                        <li :class="nav_select == 3 ? 'li_select' : ''">
                            <router-link to="/Atlas">
                                <p style="display: flex;align-items: center;">
                                    <img class="img_icon" :src="nav_select == 3 ? getAssetsFile('tupu2.png') : getAssetsFile('tupu1.png')" alt="">
                                    <span>知识图谱</span>
                                </p>
                            </router-link>
                            <p class="selectxian"></p>
                        </li>
                    </ul>
                </nav>
            </div>
            <div class="nav_right">
                <span class="nav_num">访问量{{ viewcount }}</span>
                <span>欢迎您 {{ userInfo ? userInfo.nickname : '请登录' }}</span>
                <!-- to="/PersonalCenter" -->
                <router-link :to="userInfo ? '/PersonalCenter' : '/Login'">
                    <img src="../assets/h13.png" alt="" />
                </router-link>
            </div>
            <div class="nav_right2" @click="bindmenuchange()">
                <img src="../assets/menu.png" alt="" />
            </div>
        </div>
    </header>
    <div class="nav_zhanwei"></div>
    <!-- 移动端菜单 开始 -->
    <div :class="menu ? 'nav_menu block_nav_menu' : 'nav_menu'" @click.stop="bindmenuchange()">
        <div class="nav_menu_list" @click.stop="fangchuantou()">
            <div class="menu_logo">
                <img src="../assets/logo.png" alt="">
            </div>
            <router-link class="menu_div" to="/" tag="div" active-class="menu_active">首页</router-link>
            <router-link class="menu_div" to="/AncientWorks" tag="div" active-class="menu_active">古籍</router-link>
            <router-link class="menu_div" to="/Atlas" tag="div" active-class="menu_active">图谱</router-link>
            <router-link class="menu_div" :to="userInfo ? '/PersonalCenter' : '/Login'" tag="div" active-class="menu_active">个人中心</router-link>
        </div>
    </div>
    <!-- 移动端菜单 结束 -->
</template>
<script setup>
import { ref, reactive, onMounted } from "vue";
import { post } from "@/services/api";
import { getAssetsFile } from "@/utils/public";
import { useRouter, useRoute } from "vue-router";
const router = useRouter();
const route = useRoute();

defineProps({
    nav_select: {
        type: Number,
        default: 1,
    }
});

const viewcount = ref('0');
const menu = ref(false);
const userInfo = ref(null);

// 打开关闭功能菜单
function bindmenuchange(){
    menu.value = !menu.value;
};
// 防穿透
function fangchuantou (){}

onMounted(() => {
    // 在组件挂载时调用 API 获取数据
    getCacheInfo();
    getConfig();
});
// 获取缓存信息
const getCacheInfo=async()=>{
    // 获取缓存中的用户信息
    const userInfo_linshi = localStorage.getItem('userInfo');
    if (userInfo_linshi) {
        userInfo.value = JSON.parse(userInfo_linshi);
    }
};
// 获取首页信息
const getConfig = async () => {
  try {
    const response = await post("/api/index/getconfig"); // 发送请求
    // 请求成功
    const res = response.data;
    viewcount.value = res.viewcount;
  } catch (err) {
    // 请求失败
  } finally {
    // 请求结束
  }
};
// 暴露方法，使得父组件或子路由页面可以调用
defineExpose({
    getCacheInfo,
});
</script>
<style scoped>
    header{
        width: 100%;
        height: 60px;
        background-color: rgb(240,236,231);
        position: fixed;
        z-index: 999;
    }
    .nav_main{
        width: 100%;
        max-width: 1920px;
        height: 100%;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 100px;
        box-sizing: border-box;
    }
    .nav_left{
        display: flex;
        align-items: center;
    }
    .nav_left img{
        width: 200px;
    }
    nav{
        margin-left: 50px;
    }
    nav ul li{
        display: inline-block;
        font-size: 16px;
        color: #222222;
        line-height: 60px;
        padding: 0 25px;
        transition: 0.3s;
        position: relative;
    }
    .nav ul li a{
        display: flex;
        align-items: center;
    }
    .img_icon{
        width: 16px !important;
        margin: 0 6px 0 0;
    }
    /* nav ul li:hover a{
        color: #b39d67;
    } */
    .selectxian{
        width: 0px;
        height: 4px;
        border-radius: 10px;
        background-color: rgb(143,111,55);
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        transition: 0.3s;
    }
    .li_select .selectxian{
        width: 58px;
    }
    .li_select a{
        color: rgb(143,111,55);
    }
    nav ul li:hover .selectxian{
        width: 58px;
    }
    .nav_right{
        display: flex;
        align-items: center;
    }
    .nav_right2{
        display: none;
    }
    .nav_right span{
        font-size: 16px;
        color: #222222;
        margin-right: 20px;
    }
    .nav_right img{
        width: 22px;
    }
    .nav_zhanwei{
        width: 100%;
        height: 60px;
    }
    @media screen and (max-width: 1300px) {
        .nav_main{
            padding: 0 30px;
        }
        .nav_left img{
            width: 200px;
        }
    }
    @media screen and (min-width: 450px) and (max-width: 880px) {
        nav{
            display: none;
        }
        .nav_right{
            display: none;
        }
        .nav_right2{
            width: 50px;
            height: 50px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #DBD5C6;
        }
        .nav_right2 img{
            width: 40px;
        }
    }
    @media screen and (min-width: 450px) and (max-width: 880px) {
        header{
            zoom: 1;
        }
        .nav_zhanwei{
            zoom: 1;
        }
    }
    @media screen and (max-width: 450px) {
        header{
            height: 60px;
            background-color: #FFFFFF;
        }
        .nav_main{
            max-width: 100%;
            padding: 0 12px 0 9px;
        }
        .nav_left img{
            width: 127px;
        }
        nav{
            display: none;
        }
        .nav_right{
            display: none;
        }
        .nav_right2{
            width: 25px;
            height: 25px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #DBD5C6;
        }
        .nav_right2 img{
            width: 20px;
        }
        .nav_zhanwei{
            width: 100%;
            height: 60px;
        }
    }
    /* 移动端菜单 开始 */
    .nav_menu{
        width: 0;
        height: 100%;
        min-height: 100vh;
        background-color: rgba(0,0,0,0.5);
        position: fixed;
        top: 0;
        z-index: -1;
        opacity: 0;
        transition: 0.5s;
    }
    .block_nav_menu{
        width: 100%;
        z-index: 99991;
        opacity: 1;
    }
    .nav_menu_list{
        width: 0;
        height: 100%;
        display: flex;
        flex-direction: column;
        /* zoom: 0.5; */
        opacity: 0;
        transition: 0.5s;
    }
    .block_nav_menu .nav_menu_list{
        width: 230px;
        background-color: #FCFBF7;
        opacity: 1;
    }
    .menu_logo{
        width: 127px;
        padding: 24.5px 11.5px;
    }
    .menu_logo img{
        width: 100%;
    }
    .menu_div{
        width: 100%;
        height: 50px;
        line-height: 49px;
        box-sizing: border-box;
        border-bottom: 1px solid #EAEAEA;
        padding: 0 15px;
        font-size: 15px;
        color: #222222;
    }
    .menu_active{
        background-color: #DBD5C6;
    }
    /* 移动端菜单 结束 */
</style>